var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJournalReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#E5F0EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.725 21.875c3.29 0 4.935 0 6.192.64a5.876 5.876 0 0 1 2.568 2.568c.64 1.257.64 2.902.64 6.192v16.45c0 3.29 0 4.935-.64 6.192a5.876 5.876 0 0 1-2.568 2.568c-1.257.64-2.902.64-6.192.64h-16.45c-3.29 0-4.935 0-6.192-.64a5.876 5.876 0 0 1-2.568-2.568c-.64-1.257-.64-2.902-.64-6.192v-16.45c0-3.29 0-4.935.64-6.192a5.876 5.876 0 0 1 2.568-2.568c1.257-.64 2.902-.64 6.192-.64h16.45Z",
    fill: "#006C52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.208 27.75a1.958 1.958 0 0 1-1.958 1.958h-23.5a1.958 1.958 0 1 1 0-3.916h23.5c1.081 0 1.958.876 1.958 1.958Zm-3.916 23.5a1.958 1.958 0 0 1-1.959 1.958H27.75a1.958 1.958 0 1 1 0-3.916h19.583c1.082 0 1.959.876 1.959 1.958Zm-11.75-7.833a1.958 1.958 0 0 1-1.959 1.958H27.75a1.958 1.958 0 1 1 0-3.917h7.833c1.082 0 1.959.877 1.959 1.959Zm5.875-5.875a1.958 1.958 0 1 0 0-3.917H27.75a1.958 1.958 0 1 0 0 3.917h15.667Z",
    fill: "#A0C9BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournalReport);
export default __webpack_public_path__ + "static/media/journal-report.b855a262.svg";
export { ForwardRef as ReactComponent };